/**
 * ENG-2624 — compute the next canvas multi-selection for a Cmd/Ctrl+click in the
 * move tool.
 *
 * Toggles the clicked node in/out of the current selection. When starting a fresh
 * selection (the current set is empty), it seeds the set with the node currently
 * open in the details panel (`panelSelectedId`) so that first, plain-clicked
 * object is counted too — otherwise it stays highlighted but missing from the set
 * (the "selected 3, shows 2" bug).
 */
export function computeCmdClickSelection(
  current: ReadonlySet<string>,
  clickedId: string,
  panelSelectedId?: string | null,
): Set<string> {
  const next = new Set(current)
  if (next.size === 0 && panelSelectedId && panelSelectedId !== clickedId) {
    next.add(panelSelectedId)
  }
  if (next.has(clickedId)) {
    next.delete(clickedId)
  } else {
    next.add(clickedId)
  }
  return next
}
